import { Link } from 'react-router-dom';
import './Footer.css';
import { FaInstagram, FaFacebookF, FaYoutube, FaWhatsapp } from "react-icons/fa";

// const LOGO = "/images/Logo.webp";
const LOGO1 = "/images/footlogo.webp";
const AROMA = "/images/aroma.webp";

const PRODUCT_LINKS = [
  { to: '/products/agarbatti',   icon: '🌸', label: 'Agarbatti Collection' },
  { to: '/products/dhoop-cone',  icon: '🔺', label: 'Dhoop Cone Collection' },
  { to: '/products/dhoop-stick', icon: '🪵', label: 'Dhoop Stick Collection' },
  { to: '/products/other',             icon: '✦',  label: 'Other Products' },
];


const QUICK_LINKS = [
  { to: '/',                    label: 'Home' },
  { to: '/about',               label: 'About Us' },
  { to: '/distributor-inquiry', label: 'Distributor' },
  { to: '/contact',             label: 'Contact Us' },
];

export default function Footer() {
  return (
    <footer className="footer" role="contentinfo">

      {/* decorative top border */}
      <div className="footer__top-border" />

      <div className="footer__body">

        {/* ── Brand column ── */}
        <div className="footer__brand">

          {/* Dual logo — same pattern as Navbar */}
          <Link to="/" className="footer__logo-link" aria-label="Prakhyat Home">
            <div className="footer__logo-wrap">
              <img src={LOGO1}  alt="Prakhyat Logo" className="footer__logo-img footer__logo-main"  />
              <span className="footer__logo-divider" />
              <img src={AROMA} alt="Aroma Logo"    className="footer__logo-img footer__logo-aroma" />
            </div>
          </Link>

          <p className="footer__desc">
            Puspak Aroma Products has been crafting premium agarbattis,
            dhoop cones and dhoop sticks with natural ingredients — connecting
            millions of devotees across India to the divine through the power of
            sacred fragrance.
          </p>

          <div className="footer__socials">
            <a href="https://instagram.com"           target="_blank" rel="noreferrer" aria-label="Instagram"  className="footer__social-link footer__social-link--ig"><FaInstagram /></a>
            <a href="https://facebook.com"            target="_blank" rel="noreferrer" aria-label="Facebook"   className="footer__social-link footer__social-link--fb"><FaFacebookF /></a>
            <a href="https://youtube.com"             target="_blank" rel="noreferrer" aria-label="YouTube"    className="footer__social-link footer__social-link--yt"><FaYoutube /></a>
            <a href="https://wa.me/919320905751"      target="_blank" rel="noreferrer" aria-label="WhatsApp"   className="footer__social-link footer__social-link--wa"><FaWhatsapp /></a>
          </div>

          <div className="footer__badges">
            <span>🌿 Natural</span>
            <span>✋ Handcrafted</span>
            <span>🚚 Pan-India</span>
          </div>
        </div>

        {/* ── Products column ── */}
        <div className="footer__col">
          <h3 className="footer__col-heading">Our Products</h3>
          {PRODUCT_LINKS.map(({ to, icon, label }) => (
            <Link key={to} to={to} className="footer__col-link">
              <span className="footer__col-icon">{icon}</span>{label}
            </Link>
          ))}
        </div>

        {/* ── Quick links column ── */}
        <div className="footer__col">
          <h3 className="footer__col-heading">Quick Links</h3>
          {QUICK_LINKS.map(({ to, label }) => (
            <Link key={to} to={to} className="footer__col-link">
              <span className="footer__col-icon">→</span>{label}
            </Link>
          ))}
        </div>

        {/* ── Contact column ── */}
        <div className="footer__col footer__col--contact">
          <h3 className="footer__col-heading">Contact Us</h3>
          <address>
            <div className="footer__contact-item">
              <span>📍</span>
              <p>Galano.205, 2nd Floor, Bldg No.16,<br/>
                HDIL Ind Park, CSL Chandansar Road,<br/>
                Near Riddhi Ind Est, Virar East,<br/>
                Dist. Palghar – 401303, Maharashtra</p>
            </div>
            <div className="footer__contact-item">
              <span>📞</span>
              <a href="tel:+919320905751">+91 93209 05751</a>
            </div>
            <div className="footer__contact-item">
              <span>💬</span>
              <a href="https://wa.me/919320905751" target="_blank" rel="noreferrer">WhatsApp Us</a>
            </div>
            <div className="footer__contact-item">
              <span>✉️</span>
              <a href="mailto:info@prakhyatagarbatti.com">info@prakhyatagarbatti.com</a>
            </div>
            <div className="footer__contact-item">
              <span>🕐</span>
              <p>Mon–Sat: 9 AM – 7 PM</p>
            </div>
          </address>
        </div>
      </div>

      {/* ── Bottom bar ── */}
      <div className="footer__bottom">
        <p className="footer__copy">
          © {new Date().getFullYear()} Prakhyat Agarbatti & Dhoops — Pushpak Aroma Products, Mumbai All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}